import React, { useEffect, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import RecentWorkFlip from "../Components/RecentWorkStrip";

const containerVariants = {
  initial: { opacity: 0, y: 50 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  exit: { opacity: 0, y: -30, transition: { duration: 0.3 } },
};

const works = [
  { src: "/documents/medical_thesis.pdf", type: "Medical Thesis", file_type: "pdf" },
  { src: "/documents/research.pdf", type: "Research", file_type: "pdf" },
  { src: "/documents/mba.pdf", type: "MBA Sample", file_type: "pdf" },
  { src: "/documents/ppt.pptx", type: "PowerPoint Presentation", file_type: "pptx" },
  { src: "/documents/ppt2.pptx", type: "PowerPoint Presentation 2", file_type: "pptx" },
  { src: "/documents/mba2.pdf", type: "MBA Sample 2", file_type: "pdf" },
  { src: "/documents/law.pdf", type: "LAW Sample", file_type: "pdf" },
  { src: "/documents/phd.pdf", type: "PHD Sample", file_type: "pdf" },
  { src: "/documents/phd2.pdf", type: "PHD Sample 2", file_type: "pdf" },
  
];

export default function Work() {
  const { scrollY } = useScroll();
  const yHero = useTransform(scrollY, [0, 300], [0, 100]); // Parallax effect
  const [heroLoaded, setHeroLoaded] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const img = new Image();
    img.src = "/images/hero_image.jpg";
    img.onload = () => setHeroLoaded(true);
  }, []);

  return (
    <motion.div
      // variants={containerVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="w-full px-0 py-4 max-w-screen-xl mx-auto space-y-12"
    >
      <section className="w-full text-center">
        <div className="relative inline-block mb-2">
          <div className="absolute inset-0 bg-white/30 backdrop-blur-md rounded-full px-6 py-2" />
          <h2 className="relative z-10 text-3xl sm:text-4xl font-cinzel font-semibold text-gray-800">
            Sample Work
          </h2>
        </div>
        </section>
      <RecentWorkFlip works={works} />
      <motion.section
        style={{
          backgroundImage: `url('/images/home_banner.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          y: yHero,
        }}
        className={`relative h-[60vh] sm:h-[70vh] flex items-center justify-center text-white rounded-lg overflow-hidden shadow-xl transition-opacity duration-700 ${
          heroLoaded ? "opacity-100" : "opacity-100"
        }`}
      >
        <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
        <motion.div
          className="text-center z-10"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <motion.h1
            className="text-3xl sm:text-5xl font-extrabold mb-3 bg-gradient-to-r from-purple-400 to-pink-400 text-transparent bg-clip-text"
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Fueling Ambitions One Chapter At A Time
          </motion.h1>
          <motion.p
            className="text-base sm:text-lg text-gray-200"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Making your academic journey stress-free with expert research, data analysis, writing, and presentation services.
          </motion.p>
          <motion.p
            className="font-sacramento text-3xl  mt-7 italic tracking-wide"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.2, delay: 0.6 }}
          >
            by Scholerly Edge
          </motion.p>
        </motion.div>
      </motion.section>

    </motion.div>
  );
}
